'use client';

import './project-item.scss';
import Link from 'next/link';
import { ProjectModel } from '@/lib/models/Project';
import { RouterName } from '@/lib/enum/RouterEnum';
import { useSwiperSlide } from 'swiper/react';
import { useEffect, useRef } from 'react';
import { SentenceScramble } from '@/lib/utils/SentenceScramble';
import { useSwipeUpNavigation } from '@/lib/hooks/useSwipeUpNavigation';

interface Props {
  height: number,
  project: ProjectModel;
  index: number;
  goToDetail: () => void;
  realIndex: number | null;
}

export default function ProjectMobileItem (props: Props) {
  const { height, project, index, goToDetail } = props;
  const { handleTouchStart, handleTouchEnd } = useSwipeUpNavigation({ onSwipeUp: goToDetail });
  const swiperSlide = useSwiperSlide();
  const shouldLoadVideo = swiperSlide.isActive || swiperSlide.isPrev || swiperSlide.isNext;
  const hasScrambledOnce = useRef(false); // persists across renders

  const charExits = /\W/g;
  const detailPath = `${RouterName.projectDetail}/${project.title.replaceAll(" ", "_").replace(charExits, '')}`;

  useEffect(() => {
    if (swiperSlide.isActive && !hasScrambledOnce.current) {
      const sentenceScrambler = new SentenceScramble(`project-${index}-scrambler`, () => {}, true);
      sentenceScrambler.startScramble(0.66, 0);
      // sentenceScrambler.startSequentialScramble(0.25);
      hasScrambledOnce.current = true;
    }
  }, [swiperSlide?.isActive]);

  return (
    <>
      <div className="header-slide-container" style={{ ["--window-height" as string]: `${height}px` }}>
        <dl className='project-description-list'>
          <dt className='text-title-mobile'>CLIENT</dt>
          <dd className={`text-title-desc-mobile project-${index}-scrambler`}>{project.title}</dd>
          <dt className='text-detail-mobile'>EXPERIMENT</dt>
          <dd className={`text-detail-desc-mobile`}><h2 className={`project-${index}-scrambler`}>{project.detailTitle}</h2></dd>
        </dl>
      </div>
      <div
        className={'project-list-home'}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div className="projects-list-mobile-container">
          <Link
            className='project-mobile-container'
            href={detailPath}
            aria-label={`View ${project.detailTitle} project details`}
            prefetch={false}
            onNavigate={(e) => {
              e.preventDefault();
              goToDetail();
            }}
          >
            <div className='project-mobile-border'></div>
            <div className='image-project-mobile'>
              <video
                autoPlay={shouldLoadVideo}
                loop muted
                playsInline
                src={shouldLoadVideo ? project.image : undefined}
                preload={shouldLoadVideo ? 'auto' : 'none'}
                aria-hidden="true"
              >
                <track
                  kind="captions"
                  src="/captions/no-audio.vtt"
                  srcLang="en"
                  label="No spoken audio"
                />
              </video>
            </div>
          </Link>
        </div>
      </div>
    </>
  )
};
